export type FirstPracticeChoice = 'today' | 'tomorrow' | 'weekend' | 'custom';

function toIsoDateString(date: Date): string {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function addDays(date: Date, days: number): Date {
  const result = new Date(date);
  result.setUTCDate(result.getUTCDate() + days);
  return result;
}

function nextSaturday(today: Date): Date {
  const dayOfWeek = today.getUTCDay(); // 0=Sun, 6=Sat
  const daysUntilSaturday = dayOfWeek === 6 ? 0 : 6 - dayOfWeek;
  return addDays(today, daysUntilSaturday);
}

export function resolveFirstPractice(
  choice: FirstPracticeChoice,
  today: Date,
  customDate?: string,
): string {
  switch (choice) {
    case 'today':
      return toIsoDateString(today);
    case 'tomorrow':
      return toIsoDateString(addDays(today, 1));
    case 'weekend':
      return toIsoDateString(nextSaturday(today));
    case 'custom':
      if (customDate === undefined || customDate === '') {
        throw new Error('Custom date is required when choice is "custom"');
      }
      return customDate;
  }
}

export function prefillFirstPractice(iso: string, today: Date): FirstPracticeChoice {
  if (iso === toIsoDateString(nextSaturday(today))) return 'weekend';
  if (iso === toIsoDateString(today)) return 'today';
  if (iso === toIsoDateString(addDays(today, 1))) return 'tomorrow';
  return 'custom';
}
